import React, {useEffect, useState} from 'react'
import { 
    ButtonNext, 
    ButtonPrevius, 
    ContainerPaginate,
    PageInput,
    PaginateText,
    PaginateInvalidText
} from './style'
import { language } from '../../utils/language'

const FooterPagination = ({ homeState, list, handleList, loading, isMobile }: any) => {

    const [searchPageNumber, setSearchPageNumber] = useState('')
    const [searchPageIsValid, setSearchPageIsValid] = useState(true)
    const [lastPage, setLasPage] = useState(1)
    const [currentPage, setCurrentPage] = useState(1)

    useEffect(() => {

       if(list.paginate_info)
       {
        setLasPage(parseInt(list.paginate_info.last_page));
        setCurrentPage(parseInt(list.paginate_info.current_page));
        setSearchPageNumber(list.paginate_info.current_page);
       }
 
    }, [list])

    const handleNext = () => {
        handleList(currentPage+1)
        setSearchPageIsValid(true)
    }

    const handlePrevius = () => {
        handleList(currentPage-1)
        setSearchPageIsValid(true)
    }

    const handleSearchInputKeyDown = (e:any)=>{
        if (e.key === 'Enter' && searchPageIsValid) {
            handleList(searchPageNumber)
        }
    }

    const handleSearchPageNumberChange = (page:string)=>{

        
        if(/^[0-9]+$/.test(page) || page === ""){   
            setSearchPageNumber(page)
            if((parseInt(page)<1 || parseInt(page)>lastPage) || page===""){
                setSearchPageIsValid(false)
            }else{
                setSearchPageIsValid(true)
            }
        }        
    }

    return (
        <>
        <ContainerPaginate>
            {
                !loading &&
                    
                    <>
                    {
                        currentPage > 1 &&
                        <ButtonPrevius color={homeState.color} onClick={handlePrevius}>{isMobile ? '<' : language[homeState.default_language]["prev"]}</ButtonPrevius>
                    }
                    <PaginateText>{language[homeState.default_language]["page"]}</PaginateText>
                    <PageInput
                        value={searchPageNumber} 
                        color={homeState.color}
                        valid={searchPageIsValid}
                        onKeyDown={(e)=>handleSearchInputKeyDown(e)}
                        onChange={(e)=>handleSearchPageNumberChange(e.target.value)}
                    />
                    <PaginateText>{`${language[homeState.default_language]["of"]} ${lastPage}`}</PaginateText>
                    {
                        currentPage < lastPage &&
                        <ButtonNext color={homeState.color} onClick={handleNext}>{isMobile ? '>' : language[homeState.default_language]["next"]}</ButtonNext>
                    } 
                    </>
            }
           
        </ContainerPaginate>
        {!searchPageIsValid &&
                <PaginateInvalidText>{language[homeState.default_language]["conditionPage"]}</PaginateInvalidText>
        }
        </>

    )
}

export default FooterPagination
